import type { SVGProps } from 'react';
const SvgVerticalSplit = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#vertical_split_svg__a)">
      <path
        fill="currentColor"
        d="M3 15h8v-2H3v2Zm0 4h8v-2H3v2Zm0-8h8V9H3v2Zm0-6v2h8V5H3Zm10 0h8v14h-8V5Z"
      />
    </g>
    <defs>
      <clipPath id="vertical_split_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVerticalSplit;
